// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"f3d9b5029b9c5f57","5763":"021f64f76d8501c1","6893":"6ff014bbdc3b3816","6974":"a16c7c2afde32834","7222":"0a67518aa7016bb8","7937":"e47f44afc78263fb"}[chunkId] + ".js";
};